// src/auth.js
const USER_KEY = "cmms_user_v1";
const OLD_USER_KEY = "wopro_user";
const TOKEN_KEY = "token";
const REMEMBER_KEY = "wopro_remember";

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  localStorage.removeItem(OLD_USER_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}

export function clearUser() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(OLD_USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REMEMBER_KEY);
}

export function isLoggedIn() {
  return !!getUser() && !!getToken();
}

export function isAdmin() {
  const user = getUser();
  return user?.role === "admin";
}